import { render, staticRenderFns } from "./CardUsersTable.vue?vue&type=template&id=24c51873&"
import script from "./CardUsersTable.vue?vue&type=script&lang=js&"
export * from "./CardUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports